import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import { MessageTemplate } from "../models/message-template.model";

@Injectable({ providedIn: "root" })
export class MessageTemplateService {
	private httpClient = inject(HttpClient);
	private config = inject<AppConfig>(APP_CONFIG_TOKEN);

	getActiveTemplates(): Observable<MessageTemplate[]> {
		return this.httpClient.get<MessageTemplate[]>(
			`${this.config.apiUrl}/message-templates/active`
		);
	}

	getAllTemplates(): Observable<MessageTemplate[]> {
		return this.httpClient.get<MessageTemplate[]>(
			`${this.config.apiUrl}/message-templates`
		);
	}

	createTemplate(template: Omit<MessageTemplate, '_id'>): Observable<MessageTemplate> {
		return this.httpClient.post<MessageTemplate>(
			`${this.config.apiUrl}/message-templates`,
			template
		);
	}

	updateTemplate(key: string, template: Partial<MessageTemplate>): Observable<MessageTemplate> {
		return this.httpClient.patch<MessageTemplate>(
			`${this.config.apiUrl}/message-templates/${key}`,
			template
		);
	}

	deleteTemplate(key: string): Observable<void> {
		return this.httpClient.delete<void>(
			`${this.config.apiUrl}/message-templates/${key}`
		);
	}
}
